import styled from '@emotion/styled';

export const Container = styled.div`
  width: 100%;
  height: 0;
  bottom: 0;
  border: 1px solid rgba(255, 255, 255, 0.3);
  background-color: rgba(255, 255, 255, 0.07);
  box-shadow: 0px 26px 59px 0px rgba(0, 0, 0, 0.18);
  transition: all ease 1s 0s;
  @media screen and (min-height: 832px) {
    height: 64px;
  }
`;

export const InfoList = styled.ul`
  height: 100%;
  display: none;
  gap: 31px;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  color: #ffffff;
  @media screen and (min-height: 832px) {
    display: flex;
  }
`;

export const InfoItem = styled.li`
  &:not(:first-of-type):before {
    display: block;
    position: absolute;
    bottom: 0;
    left: -16px;
    clear: both;
    background-color: #ffffff;
    width: 1px;
    height: 12px;
    content: '';
  }
  display: flex;
  gap: 4px;
  align-items: center;
  position: relative;
  opacity: 0.7;
  font-weight: 300;
  vertical-align: 2px;
`;
export const Icon = styled.img``;

export const Privacy = styled.a``;
